import { render, staticRenderFns } from "./StatusProductChips.vue?vue&type=template&id=2307b8ca&scoped=true&"
import script from "./StatusProductChips.vue?vue&type=script&lang=js&"
export * from "./StatusProductChips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2307b8ca",
  null
  
)

export default component.exports